import React from 'react';
import Button from '../../components/button/Button';
import Popup from './Popup';
import { getPopupContent, getPreviousPeriod } from './utils';
import { usePopupContext } from '../contexts/PopupContext';
import { PERIOD_LABEL } from '../../constants/enrollment';

const TRCOutsideBMPopup = () => {
    const {
        params: { name, period },
        actions: { hideTRCOutsideBMPopup },
    } = usePopupContext();

    const { header, okButtonText } = getPopupContent(name);
    return (
        <Popup
            cssClass="trc-outside-bm-popup"
            header={header}
            message={`This result does not have item level details, and cannot be deleted because this score is the proficiency level reported from the ${
                PERIOD_LABEL[getPreviousPeriod(period)]
            }
            screening, and the benchmark window is closed.`}
            buttons={[
                <Button
                    cssClasses="hide-trc-button-popup"
                    key="continue-button"
                    onClick={hideTRCOutsideBMPopup}
                >
                    {okButtonText}
                </Button>,
            ]}
        />
    );
};

export default TRCOutsideBMPopup;
